import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { TableFooters } from 'components/table/private/TableFooters';
import { TableRow } from 'components/table/private/TableRow';
import './TableFoot.scss';
/**
 * @component TableFoot
 * @since 1.0.0
 * @hidden
 */
export function TableFoot(props) {
    const { style, schema } = Object.assign({ style: 'normal' }, props);
    const className = classNames('table-foot', 'table-foot--' + style);
    return (React.createElement("tfoot", { className: className },
        React.createElement(TableRow, null,
            React.createElement(TableFooters, { schema: schema }))));
}
